/**
 * Mobile handlers for the Today list (`data-mobile-action="today-*"`).
 * Thin wrappers over the shared execution callbacks; every handler ends with
 * a re-render because execution changes are not tree changes.
 */

import { toggleRoutineInNote } from '../../ui/routines.js';

export function handleTodayAction(action, actionEl, deps) {
  const { callbacks, uiState, scheduleRender } = deps;
  const sc = callbacks.sharedCallbacks;
  if (!sc?.isExecutionEnabled?.()) return false;
  const readOnly = !!callbacks.Store?.isReadOnly?.();
  const noteId = actionEl.dataset.noteId || null;
  const nodeId = actionEl.dataset.nodeId || null;

  switch (action) {
    case "today-tick": {
      if (readOnly || !noteId || !nodeId) return true;
      const on = actionEl.getAttribute('aria-checked') !== 'true';
      sc.setExecutionWorked(noteId, nodeId, on, JSON.parse(actionEl.dataset.workedDates || '[]'));
      break;
    }
    case "today-done": {
      if (readOnly || !nodeId) return true;
      const doneTagId = sc.getDoneTagId?.(nodeId);
      if (doneTagId) sc.toggleNodeTag(nodeId, doneTagId);
      break;
    }
    case "today-pin": {
      if (readOnly || !noteId || !nodeId) return true;
      const item = sc.getExecutionItems({ noteId }).find((e) => e.nodeId === nodeId);
      sc.setExecutionPinned(noteId, nodeId, !(item && item.pinned));
      break;
    }
    case "today-remove":
      if (readOnly || !noteId || !nodeId) return true;
      sc.removeFromExecution(noteId, nodeId);
      break;
    case "today-carry-toggle":
      uiState.todayCarryOpen = !uiState.todayCarryOpen;
      break;
    case "today-carry-cancel":
      uiState.todayCarryOpen = false;
      break;
    case "today-carry-confirm": {
      if (readOnly || !noteId) return true;
      const picks = [...deps.container.querySelectorAll(".mobile-today-carry-pick:checked")].map((el) => el.dataset.nodeId);
      const candidates = sc.getCarryCandidates?.(noteId) || [];
      // Sends prepend, so retain the displayed order by inserting backwards.
      for (const id of picks.reverse()) {
        const c = candidates.find((x) => x.nodeId === id);
        sc.sendToExecution(noteId, id, { pinned: c ? c.pinned : null });
      }
      uiState.todayCarryOpen = false;
      break;
    }
    case "today-add": {
      if (readOnly || !noteId) return true;
      const input = deps.container.querySelector("#mobile-today-add");
      const name = (input?.value || "").trim();
      if (!name) return true;
      const parentId = sc.ensureUnsortedBranch?.();
      if (!parentId) return true;
      const id = sc.generateId?.() || `n-${Date.now()}`;
      sc.addNode(parentId, { id, name, children: [] });
      sc.sendToExecution(noteId, id);
      if (input) input.value = "";
      uiState.todayDrafts?.delete(noteId);
      break;
    }
    case "today-toggle-node": {
      // From the node panel: add to / remove from the current period's list.
      if (readOnly || !nodeId) return true;
      const stats = sc.getExecutionStats?.();
      const current = stats?.currentPeriod?.noteId || null;
      if (!current) return true;
      if(toggleRoutineInNote(nodeId,current))break;
      const on = sc.getExecutionItems({ noteId: current }).some((e) => e.nodeId === nodeId);
      if (on) sc.removeFromExecution(current, nodeId); else sc.sendToExecution(current, nodeId);
      break;
    }
    default:
      return false;
  }
  scheduleRender?.();
  return true;
}
